import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Button,
  Link,
  Grid,
  Row,
  Col,
  Panel,
  Hr,
  Margin,
  Table,
  Text,
} from 'shared/components'
import { admin } from 'routes/route.map'

import { TournamentsFilters } from './components/filters'
import * as styles from './styles'

const TournamentsOverviewComponent = ({ columns, onSearch, loadAthletes }) => (
  <Panel>
    <Text as="h1" size={16} bold>
      Tournaments
    </Text>
    <Margin tb={3}>
      <Hr width="full" />
    </Margin>
    <Margin tb={3}>
      <Grid>
        <Row>
          <Col xs={12} sm={10}>
            <TournamentsFilters debounce={250} onSearch={onSearch} />
          </Col>
          <Col xs={12} sm={2}>
            <div css={styles.controlsWrapper}>
              <Link to={admin.tournaments.add()}>
                <Button plain>
                  <FontAwesomeIcon size="1x" icon="plus-circle" />
                  <Text size={11}>Add tournament</Text>
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </Grid>
    </Margin>
    <Table id="tournament-table" columns={columns} loadData={loadAthletes} />
  </Panel>
)

TournamentsOverviewComponent.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()),
  loadAthletes: PropTypes.func,
  onSearch: PropTypes.func.isRequired,
}

export default TournamentsOverviewComponent
